import React from 'react';
import { FDStack, FDBodyText } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import OutcomeIcon from 'Components/ComponentLibrary/Organisms/Outcome/OutcomeIcon';

export default function OutcomeStat({ type, title, subtitle }) {
  return (
    <FDStack spacing={1} alignItems={'center'}>
      <OutcomeIcon type={type} />
      <FDBodyText value={title} label={subtitle} />
    </FDStack>);
}
OutcomeStat.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
